import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { KeycloakService } from 'keycloak-angular';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { NzSelectOptionInterface } from 'ng-zorro-antd/select';
import { SwalToastService } from 'src/app/services/swal.service';
import { IAddDischarge } from 'src/app/interfaces/Discharge/IAddDischarge';
import { IDischargeDropdown } from 'src/app/interfaces/Discharge/IDischargeDropdown';
import {
  IAccommodationDropdown,
  IBuilding,
  IFloor,
  IRoom,
  IWard,
} from 'src/app/interfaces/Dropdown/IAccommodationDropdown';
import { ICoding } from 'src/app/interfaces/ICoding';
import { IInpatient } from 'src/app/interfaces/IInpatient';
import {
  ardsRV,
  glasgowScoreRV,
  mewsRV,
} from 'src/app/interfaces/IReferenceValue';
import { ISearchInpatient } from 'src/app/interfaces/ISearchInpatient';
import { AllergyService } from 'src/app/services/allergy.service';
import { CarePlanService } from 'src/app/services/carePlan.service';
import { CareTeamService } from 'src/app/services/careTeam.service';
import { ICareTeam } from 'src/app/interfaces/CareTeam/ICareTeam';
import { ICarePlanDetailed } from 'src/app/interfaces/CarePlan/ICarePlan';
import { CurrentMedicationService } from 'src/app/services/currentMedication.service';
import { CurrentProblemsService } from 'src/app/services/currentProblems.service';
import { DischargeService } from 'src/app/services/discharge.service';
import { EpisodeOfCareService } from 'src/app/services/episodeOfCare.service';
import { HysteroscopyFileService } from 'src/app/services/hyseroscopyFile.service';
import { ImagingService } from 'src/app/services/imaging.service';
import { InitialAssessmentService } from 'src/app/services/initialAssessment.service';
import { InpatientService } from 'src/app/services/inpatient.service';
import { InPatientExternalRefresh } from 'src/app/services/inPatientExternalRefresh.service';
import { LaboratoryFileService } from 'src/app/services/laboratoryFile.service';
import { MedicalAlertService } from 'src/app/services/medicalAlert.service';
import { MedicalDeviceService } from 'src/app/services/medicalDevice.service';
import { MedicalHistoryService } from 'src/app/services/medicalHistory.service';
import { PastMedicationService } from 'src/app/services/pastMedication.service';
import { PatientService } from 'src/app/services/patient.service';
import { PregnancyHistoryService } from 'src/app/services/pregnancyHistory.service';
import { PregnancyOutcomeService } from 'src/app/services/pregnancyOutcome.service';
import { PregnancyStatusService } from 'src/app/services/pregnancyStatus.service';
import { ProcedureService } from 'src/app/services/procedure.service';
import { ResolvedProblemsService } from 'src/app/services/resolvedProblems.service';
import { SocialHistoryService } from 'src/app/services/socialHistory.service';
import { SupportingDocumentsService } from 'src/app/services/supportingDocuments.service';
import { TokenService } from 'src/app/services/token.service';
import { TravelHistoryService } from 'src/app/services/travelHistory.service';
import { VaccinationService } from 'src/app/services/vaccination.service';
import { VitalSignService } from 'src/app/services/vitalSign.service';
import Swal from 'sweetalert2';
import { IGetVisit } from 'src/app/interfaces/IGetVisit';
import { PermissionService } from 'src/app/services/permission.service';
import { forkJoin, map, Observable, of, switchMap } from 'rxjs';
import { SelfReportService } from 'src/app/services/selfReport.service';
import moment from 'moment';
import { date_format } from 'src/date/date.configuration';
import { DepartmentalQuestionnairesService } from 'src/app/services/departmentalQuestionnaires.service';
import { COLORS } from 'src/styles/colors';

@Component({
  selector: 'app-in-patients',
  templateUrl: './in-patients.component.html',
  styleUrls: ['./in-patients.component.css'],
  providers: [DatePipe],
  standalone: false,
})
export class InPatientsComponent {
  @ViewChild('inpaginator', { static: true }) paginator!: MatPaginator;

  @ViewChild('bedModalRef', { static: true }) bedModalRef!: NzModalRef;
  @ViewChild('dischargeModalRef', { static: true })
  dischargeModalRef!: NzModalRef;

  @ViewChild('visitModalRef', { static: true }) visitModalRef!: NzModalRef;

  @ViewChild('activeCareServiceModalRef', { static: true })
  activeCareServiceModalRef!: NzModalRef;

  icu: boolean = false;

  bedForm: FormGroup = new FormGroup({});
  dischargeForm: FormGroup = new FormGroup({});

  bedSubmitted = false;
  dischargeSubmitted = false;

  situationDisabled = false;

  isLoading = false;
  isProfileLoading = false;
  isNewVisitLoading = false;

  isAssignLoading = false;
  isDischargeLoading = false;

  isMoveVisible = false;
  isAssignVisible = false;
  isDischargeVisible = false;
  isVisitLoading = false;
  isVisitVisible = false;
  isNewSelected = true;
  draftVisit?: number;

  isActiveCareServiceVisible = false;
  activeCareServiceOption: string | null = null;
  selectedDischargeItem?: IInpatient;
  activeCareTeamMembers: ICareTeam[] = [];
  activeCarePlans: ICarePlanDetailed[] = [];

  existingVisits: IGetVisit[] | null = null;

  isPreRegistration: boolean = false;

  public availablePatients: NzSelectOptionInterface[] = [];
  public reasons: ICoding[] = [];

  public data: MatTableDataSource<IInpatient> =
    new MatTableDataSource<IInpatient>([]);
  private tableData: any[] = [];

  public totalRecords: number = 0;

  public metricsData: any[] = [];

  public dischargeVisible?: boolean;

  dischargeDropdown?: IDischargeDropdown;

  finalDiagnosis: NzSelectOptionInterface[] = [];

  dropdownData: IAccommodationDropdown = {
    buildings: [],
  };

  ddBuildings: IBuilding[] = [];
  ddWards: IWard[] = [];
  ddFloors: IFloor[] = [];
  ddRooms: IRoom[] = [];

  selectedBuilding: IBuilding | null = null;
  selectedFloor: IFloor | null = null;
  selectedWard: IWard | null = null;
  selectedRoom: IRoom | null = null;
  selectedPatientFullName: string = '';
  selectedPatientID?: number;
  selectedEOC?: number;

  public displayedColumns: string[] = [];

  public ardsRV = ardsRV;
  public mewsRV = mewsRV;
  public glasgowScoreRV = glasgowScoreRV;

  public profilePictures: Record<number, string> = {};

  ngAfterViewInit() {
    this.data.paginator = this.paginator;
  }

  constructor(
    private readonly inpatientService: InpatientService,
    private readonly keycloakService: KeycloakService,
    private readonly eocService: EpisodeOfCareService,
    private readonly patientService: PatientService,
    private readonly router: Router,
    private readonly fb: FormBuilder,
    private readonly allergyService: AllergyService,
    private readonly vaccinationService: VaccinationService,
    private readonly medicalAlertService: MedicalAlertService,
    private readonly medicalHistoryService: MedicalHistoryService,
    private readonly procedureService: ProcedureService,
    private readonly medicalDeviceService: MedicalDeviceService,
    private readonly currentProblemsService: CurrentProblemsService,
    private readonly resolvedProblemsService: ResolvedProblemsService,
    private readonly pregnancyHistoryService: PregnancyHistoryService,
    private readonly pregnancyOutcomeService: PregnancyOutcomeService,
    private readonly pregnancyStatusService: PregnancyStatusService,
    private readonly carePlanService: CarePlanService,
    private readonly careTeamService: CareTeamService,
    private readonly socialHistoryService: SocialHistoryService,
    private readonly initialAssessmentService: InitialAssessmentService,
    private readonly departmentalQuestionnairesService: DepartmentalQuestionnairesService,
    private readonly travelHistoryService: TravelHistoryService,
    private readonly currentMedicationService: CurrentMedicationService,
    private readonly pastMedicationService: PastMedicationService,
    private readonly imagingService: ImagingService,
    private readonly labService: LaboratoryFileService,
    private readonly supportingDocumentsService: SupportingDocumentsService,
    private readonly hysteroscopyFileService: HysteroscopyFileService,
    private readonly vitalSignService: VitalSignService,
    private readonly dischargeService: DischargeService,
    private readonly selfReportService: SelfReportService,
    private readonly translate: TranslateService,
    private readonly tokenService: TokenService,
    private refreshService: InPatientExternalRefresh,
    private route: ActivatedRoute,
    private readonly swalToastService: SwalToastService,
    private readonly permissionService: PermissionService,
    private readonly cdr: ChangeDetectorRef,
  ) {
    this.bedForm = this.fb.group({
      patientValue: ['', Validators.required],
      bedValue: ['', Validators.required],
      methodValue: ['', Validators.required],
      noteValue: [''],
    });

    this.dischargeForm = this.fb.group({
      diagnosisValue: ['', Validators.required],
      dischargeTypeValue: ['', Validators.required],
      dischargeSituationValue: ['', Validators.required],
      dischargeTypeNotesValue: [''],
      dischargeSituationNotesValue: [''],
      eocValue: ['', Validators.required],
    });
  }

  getRow(element: any) {
    return (
      this.metricsData?.find((d: any) => d?.id === element?.id) || undefined
    );
  }

  onBuildingChange(building: IBuilding) {
    this.selectedBuilding = building;

    this.selectedFloor = null;
    this.selectedWard = null;
    this.selectedRoom = null;

    this.ddFloors = building.floors;
    this.ddWards = building.floors.flatMap((floor) => floor.wards);
    this.ddRooms = this.ddWards.flatMap((ward) => ward.rooms);

    this.refreshTable();
  }

  onFloorChange(floor: IFloor) {
    this.selectedFloor = floor;

    this.selectedWard = null;
    this.selectedRoom = null;

    if (floor) {
      this.ddWards = floor.wards;
      this.ddRooms = floor.wards.flatMap((ward) => ward.rooms);
    } else {
      this.ddFloors =
        this.ddBuildings.find((b) => b.id == this.selectedBuilding?.id)
          ?.floors || this.ddBuildings.flatMap((b) => b.floors);
      this.ddWards =
        this.ddFloors.find((f) => f.id == this.selectedFloor?.id)?.wards ||
        this.ddFloors.flatMap((f) => f.wards);
      this.ddRooms =
        this.ddWards.find((w) => w.id == this.selectedWard?.id)?.rooms ||
        this.ddWards.flatMap((w) => w.rooms);
    }

    this.refreshTable();
  }

  onWardChange(ward: IWard) {
    this.selectedWard = ward;

    this.selectedRoom = null;

    if (ward) {
      this.ddRooms = ward.rooms;
    } else {
      this.ddWards =
        this.ddFloors.find((f) => f.id == this.selectedFloor?.id)?.wards ||
        this.ddFloors.flatMap((f) => f.wards);
      this.ddRooms =
        this.ddWards.find((w) => w.id == this.selectedWard?.id)?.rooms ||
        this.ddWards.flatMap((w) => w.rooms);
    }

    this.refreshTable();
  }

  onRoomChange(room: IRoom) {
    if (room) {
      this.selectedRoom = room;
    } else {
      this.ddRooms =
        this.ddWards.find((w) => w.id == this.selectedWard?.id)?.rooms ||
        this.ddWards.flatMap((w) => w.rooms);
    }

    this.refreshTable();
  }

  async searchPatientsForm() {
    this.isLoading = true;

    const searchParams: ISearchInpatient = {};

    if (this.selectedBuilding != null) {
      searchParams.buildingId = this.selectedBuilding.id;
    }

    if (this.selectedFloor != null) {
      searchParams.floorId = this.selectedFloor.id;
    }

    if (this.selectedWard != null) {
      searchParams.wardId = this.selectedWard.id;
    }

    if (this.selectedRoom != null) {
      searchParams.roomId = this.selectedRoom.id;
    }

    await this.inpatientService
      .getInpatients(
        searchParams,
        this.paginator.pageSize,
        this.paginator.pageIndex + 1,
      )
      .subscribe({
        next: (d) => {
          this.data = new MatTableDataSource(
            d?.data?.map((d: IInpatient) => d),
          );

          this.tableData = d?.data?.map((d: IInpatient) => d);

          this.metricsData = this.tableData.map((d) => {
            if (!d.bedIsAvailable) {
              return {
                id: d.id,
                sepsis: Math.floor(Math.random() * 5),
                saps2: Math.floor(Math.random() * (163 + 1)),
                apache2: Math.floor(Math.random() * (71 + 1)),
                apache4: Math.floor(Math.random() * (30 + 1)) + 256,
                sofa: Math.floor(Math.random() * (24 + 1)),
                ards: Math.floor(Math.random() * (300 + 1)),
                mews: Math.floor(Math.random() * (13 + 1)) + 2,
                glasgow: Math.floor(Math.random() * (12 + 1)) + 3,
              };
            } else {
              return undefined;
            }
          });

          this.totalRecords = d.totalRecords || 0;

          this.isLoading = false;

          this.isProfileLoading = true;

          const requests = d?.data
            .map((d) => {
              if (d.inPatientInfo?.patientId) {
                return this.patientService
                  .getProfilePicture(d.inPatientInfo?.patientId?.toString()!)
                  .pipe(
                    map((blob?: Blob) => {
                      if (blob && blob.type.startsWith('image/')) {
                        return new Promise<void>((resolve) => {
                          const reader = new FileReader();
                          reader.onload = () => {
                            this.profilePictures[d.inPatientInfo?.patientId!] =
                              reader.result?.toString() || '';
                            resolve();
                          };
                          reader.readAsDataURL(blob);
                        });
                      }
                      return Promise.resolve();
                    }),
                  );
              }
              return null;
            })
            .filter((request) => request !== null);

          if (requests.length > 0) {
            forkJoin(requests).subscribe({
              next: () => {
                this.cdr.detectChanges();
                this.isProfileLoading = false;
              },
              error: (error) => {
                console.error('Error fetching profile pictures:', error);
                this.isProfileLoading = false;
              },
            });
          } else {
            this.isProfileLoading = false;
          }
        },
        error: (err) => {},
      });
  }

  getDropdownData() {
    this.inpatientService.getDropdownData().subscribe({
      next: (d) => {
        this.dropdownData = d.data;
        this.ddBuildings = d.data.buildings;
        this.ddFloors = this.ddBuildings.flatMap((b) => b.floors);
        this.ddWards = this.ddFloors.flatMap((f) => f.wards);
        this.ddRooms = this.ddWards.flatMap((w) => w.rooms);
      },
      error: (err) => {},
    });
  }

  ngOnInit() {
    this.route.data.subscribe((data) => {
      this.icu = data['icu'];
    });

    this.permissionService.can(['disc']) // has discharge permission
      ? (this.dischargeVisible = true)
      : (this.dischargeVisible = false);

    if (!this.icu) {
      this.isPreRegistration = true;

      this.displayedColumns = [
        'profile',
        'locationInpatient',
        'bedNumber',
        'patientfullName',
        'patientAge',
        'lengthOfStay',
        // 'admissionDate',
        'inpatientActions',
      ];
    } else {
      this.isPreRegistration = false;

      this.displayedColumns = [
        'profile',
        'locationInpatient',
        'bedNumber',
        'patientfullName',
        'patientAge',
        'los',
        'sepsis',
        'saps2',
        'apache2',
        'apache4',
        'sofa',
        'ards',
        'mews',
        'glasgow',
        // 'admissionDate',
        'inpatientActions',
      ];
    }

    // if (this.userRoles.includes('read-only')) {
    //   this.displayedColumns = this.displayedColumns.filter(
    //     (column) => column !== 'inpatientActions'
    //   );
    // }

    this.paginator.pageSize = 5; // Set default page size to 5

    this.refreshService.refreshInpatientsList$.subscribe(() => {
      this.searchPatientsForm();
    });

    this.searchPatientsForm();
    this.getDropdownData();
  }

  handleAssignCancel() {
    this.isAssignVisible = false;

    this.bedForm.reset();

    this.bedSubmitted = false;

    this.isLoading = false;
    this.isNewVisitLoading = false;

    this.bedModalRef.destroy();
  }

  handleDischargeCancel() {
    this.isDischargeVisible = false;

    this.dischargeForm.reset();

    this.dischargeSubmitted = false;

    this.isLoading = false;
    this.isNewVisitLoading = false;

    this.activeCareServiceOption = null;
    this.selectedDischargeItem = undefined;
    this.activeCareTeamMembers = [];
    this.activeCarePlans = [];

    this.dischargeModalRef.destroy();
  }

  handleVisitCancel() {
    this.resetVisitCancel();

    this.visitModalRef.destroy('cancel');
  }

  handleDischargeClick(item: IInpatient) {
    const eocId = item?.inPatientInfo?.episodeOfCareId;

    if (!eocId) {
      this.openActiveCareService(item);
      return;
    }

    this.isLoading = true;

    this.eocService.getDraftVisitFromEOC(eocId).subscribe({
      next: (res) => {
        this.isLoading = false;

        if (res?.data?.length) {
          this.showDraftVisitsWarning();
        } else {
          this.openActiveCareService(item);
        }
      },
      error: () => {
        this.isLoading = false;
        this.swalToastService.toastError('Unable to retrieve draft visits');
        this.openActiveCareService(item);
      },
    });
  }

  private showDraftVisitsWarning() {
    Swal.fire({
      icon: 'warning',
      title: this.translate.instant('Action Not Allowed'),
      text: this.translate.instant(
        'You currently have draft visit(s) for this patient. You must either discard them or submit them to discharge this patient',
      ),
      confirmButtonColor: COLORS.green,
    });
  }

  openActiveCareService(item: IInpatient) {
    this.selectedDischargeItem = item;

    const patientId = item?.inPatientInfo?.patientId;

    if (!patientId) {
      this.handleDischarge(item);
      return;
    }

    forkJoin({
      careTeams: this.careTeamService.getActiveCareTeams(patientId.toString()),
      carePlans: this.carePlanService.getActiveCarePlans(patientId),
    }).subscribe({
      next: ({ careTeams, carePlans }) => {
        this.activeCareTeamMembers = careTeams?.data || [];
        this.activeCarePlans = carePlans?.data || [];

        if (this.activeCareTeamMembers.length || this.activeCarePlans.length) {
          this.isActiveCareServiceVisible = true;
        } else {
          this.handleDischarge(item);
        }
      },
      error: () => {
        this.swalToastService.toastError(
          'Unable to retrieve active care services',
        );
        this.handleDischarge(item);
      },
    });
  }

  handleActiveCareServiceCancel() {
    this.isActiveCareServiceVisible = false;

    this.activeCareServiceOption = null;
    this.selectedDischargeItem = undefined;
    this.activeCareTeamMembers = [];
    this.activeCarePlans = [];

    this.activeCareServiceModalRef.destroy();
  }

  handleActiveCareServiceProceed() {
    const item = this.selectedDischargeItem;

    this.isActiveCareServiceVisible = false;

    this.activeCareServiceModalRef.destroy();

    if (item) {
      this.handleDischarge(item);
    }
  }

  clearDataFromServices() {
    this.allergyService.allergyDataSub.next({});
    this.vaccinationService.vaccinationDataSub.next([]);
    this.medicalAlertService.medicalAlertDataSub.next([]);
    this.medicalHistoryService.medicalHistoryDataSub.next([]);
    this.procedureService.procedureDataSub.next({});
    this.medicalDeviceService.medicalDeviceDataSub.next({});
    this.currentProblemsService.currentProblemDataSub.next({});
    this.resolvedProblemsService.resolvedProblemDataSub.next([]);
    this.pregnancyHistoryService.pregnancyHistoryDataSub.next([]);
    this.pregnancyOutcomeService.pregnancyOutcomeDataSub.next([]);
    this.pregnancyStatusService.pregnancyStatusDataSub.next([]);
    this.carePlanService.carePlanDataSub.next([]);
    this.socialHistoryService.socialHistoryDataSub.next([]);
    this.initialAssessmentService.initialAssessmentDataSub.next([]);
    this.departmentalQuestionnairesService.departmentalQuestionnairesDataSub.next(
      [],
    );
    this.travelHistoryService.travelHistoryDataSub.next([]);
    this.currentMedicationService.currentMedicationDataSub.next({});
    this.pastMedicationService.pastMedicationDataSub.next([]);
    this.imagingService.imagingDataSub.next([]);
    this.labService.laboratoryDataSub.next([]);
    this.supportingDocumentsService.supportingDocumentDataSub.next([]);
    this.hysteroscopyFileService.hysteroscopyDataSub.next([]);
    this.vitalSignService.vitalSignDataSub.next([]);
    this.selfReportService.selfReportDataSub.next([]);
  }

  async submitDischargeForm() {
    this.isDischargeLoading = true;
    this.dischargeSubmitted = true;

    if (this.dischargeForm.valid) {
      const dischargeObj: IAddDischarge = {};
      dischargeObj.episodeCareId = this.dischargeForm.get('eocValue')?.value;
      dischargeObj.finalDiagnosisId =
        this.dischargeForm.get('diagnosisValue')?.value;
      dischargeObj.dischargeTypeId =
        this.dischargeForm.get('dischargeTypeValue')?.value;
      dischargeObj.dischargeTypeNotes =
        this.dischargeForm.get('dischargeTypeNotesValue')?.value || undefined;
      dischargeObj.dischargeSituationId = this.dischargeForm.get(
        'dischargeSituationValue',
      )?.value;
      dischargeObj.dischargeSituationNotes =
        this.dischargeForm.get('dischargeSituationNotesValue')?.value ||
        undefined;

      const eocId = this.selectedDischargeItem?.inPatientInfo?.episodeOfCareId;

      if (
        eocId &&
        this.activeCareServiceOption &&
        this.activeCareServiceOption !== 'keepBoth'
      ) {
        this.stopActiveCareServicesThenDischarge(eocId, dischargeObj);
      } else {
        this.finalizeDischarge(dischargeObj);
      }
    } else {
      this.isDischargeLoading = false;
    }
  }

  private resolveVisitContext(eocId: number): Observable<void> {
    return this.eocService.getDraftVisitFromEOC(eocId).pipe(
      switchMap((res) => {
        const draftVisit = res?.data?.[0];

        if (draftVisit?.id) {
          this.eocService.currentEocId.set(eocId.toString());
          this.eocService.currentVisitId.set(draftVisit.id.toString());
          return of(undefined);
        }

        return this.eocService.createNewVisit(eocId).pipe(
          map((createRes) => {
            createRes?.data?.episodeOfCareId &&
              this.eocService.currentEocId.set(
                createRes.data.episodeOfCareId.toString(),
              );
            createRes?.data?.visitId &&
              this.eocService.currentVisitId.set(
                createRes.data.visitId.toString(),
              );
          }),
        );
      }),
    );
  }

  private stopActiveCareServicesThenDischarge(
    eocId: number,
    dischargeObj: IAddDischarge,
  ) {
    const patientId = this.selectedDischargeItem?.inPatientInfo?.patientId;
    patientId && this.patientService.patientIDsignal.set(patientId.toString());

    this.resolveVisitContext(eocId).subscribe({
      next: () => {
        const stopCalls: Observable<unknown>[] = [];

        if (
          this.activeCareServiceOption === 'stopCareTeam' ||
          this.activeCareServiceOption === 'stopBoth'
        ) {
          this.activeCareTeamMembers.forEach((careTeam) => {
            careTeam.id &&
              stopCalls.push(
                this.careTeamService.unassignCareTeam(careTeam.id.toString()),
              );
          });
        }

        if (
          this.activeCareServiceOption === 'stopCarePlan' ||
          this.activeCareServiceOption === 'stopBoth'
        ) {
          const visitId = this.eocService.currentVisitId();

          this.activeCarePlans.forEach((carePlan) => {
            stopCalls.push(
              this.carePlanService.stopCarePlan(carePlan.id, visitId),
            );
          });
        }

        const stops$: Observable<unknown> = stopCalls.length
          ? forkJoin(stopCalls)
          : of(null);

        stops$.subscribe({
          next: () => {
            dischargeObj.finalDiagnosisId &&
              this.eocService.setPD(dischargeObj.finalDiagnosisId);
            this.eocService.setEnded(true);

            this.eocService.saveVisit().subscribe({
              next: () => this.finalizeDischarge(dischargeObj),
              error: () => {
                this.swalToastService.toastError('Unable to save the visit');
                this.isDischargeLoading = false;
              },
            });
          },
          error: () => {
            this.swalToastService.toastError(
              'Unable to stop active care services',
            );
            this.isDischargeLoading = false;
          },
        });
      },
      error: () => {
        this.swalToastService.toastError('Unable to resolve the patient visit');
        this.isDischargeLoading = false;
      },
    });
  }

  private finalizeDischarge(dischargeObj: IAddDischarge) {
    this.dischargeService.addDischarge(dischargeObj).subscribe({
      next: () => {
        if (!this.shouldCreateOutpatientEpisodeOfCare()) {
          void this.completeDischarge();
          return;
        }

        const patientId =
          this.selectedDischargeItem?.inPatientInfo?.patientId?.toString();

        if (!patientId) {
          void this.completeDischarge(true);
          return;
        }

        this.eocService.createEpisodeOfCare(patientId).subscribe({
          next: () => void this.completeDischarge(),
          error: () => void this.completeDischarge(true),
        });
      },
      error: () => {
        this.swalToastService.toastError('Unable to discharge patient');
        this.isDischargeLoading = false;
      },
    });
  }

  private shouldCreateOutpatientEpisodeOfCare(): boolean {
    if (!this.activeCareServiceOption) {
      return false;
    }

    const preservesCareTeam =
      this.activeCareTeamMembers.length > 0 &&
      this.activeCareServiceOption !== 'stopCareTeam' &&
      this.activeCareServiceOption !== 'stopBoth';
    const preservesCarePlan =
      this.activeCarePlans.length > 0 &&
      this.activeCareServiceOption !== 'stopCarePlan' &&
      this.activeCareServiceOption !== 'stopBoth';

    return preservesCareTeam || preservesCarePlan;
  }

  private async completeDischarge(
    outpatientEpisodeCreationFailed = false,
  ): Promise<void> {
    this.isDischargeLoading = false;

    await this.searchPatientsForm().then(() => {
      this.isDischargeVisible = false;
    });

    this.dischargeForm.setErrors(null);
    this.bedForm.setErrors(null);

    this.dischargeModalRef.destroy();

    this.dischargeSubmitted = false;

    this.activeCareServiceOption = null;
    this.selectedDischargeItem = undefined;
    this.activeCareTeamMembers = [];
    this.activeCarePlans = [];

    if (outpatientEpisodeCreationFailed) {
      this.swalToastService.toastError(
        'Patient discharged, but outpatient episode of care could not be created',
      );
      return;
    }

    this.swalToastService.toastSuccess(
      'Patient discharged successfully',
    );
  }

  async submitBedForm() {
    this.isAssignLoading = true;
    this.bedSubmitted = true;

    if (this.bedForm.valid) {
      this.eocService
        .createInpatient(
          this.bedForm.get('patientValue')?.value || undefined,
          this.bedForm.get('bedValue')?.value || undefined,
          this.bedForm.get('methodValue')?.value || undefined,
          this.bedForm.get('noteValue')?.value || undefined,
        )
        .subscribe({
          next: async (res) => {
            // SET EOC AND VISIT IDs
            res?.data?.episodeOfCareId?.toString() &&
              this.eocService.currentEocId.set(
                res?.data?.episodeOfCareId?.toString(),
              );

            res?.data?.visitId?.toString() &&
              this.eocService.currentVisitId.set(
                res?.data?.visitId?.toString(),
              );

            // SET PATIENT ID
            this.patientService.patientIDsignal.set(
              this.bedForm.get('patientValue')?.value,
            );

            this.isAssignLoading = false;

            // UPDATE TABLE
            await this.searchPatientsForm().then(() => {
              this.isAssignVisible = false;
            });

            this.dischargeForm.setErrors(null);
            this.bedForm.setErrors(null);

            this.bedModalRef.destroy();

            this.bedSubmitted = false;

            // RESET DATA  BEFORE ACCESSING A PATIENT
            this.clearDataFromServices();

            // WAIT 100MS FOR THE HTML MODAL TO BE UPDATED AND CLOSED
            // AND THEN PROCEED WITH THE REDIRECTION
            setTimeout(() => {
              this.router.navigate([
                '/ehr/inPatientView',
                this.patientService.patientIDsignal(),
                this.eocService.currentEocId(),
                this.eocService.currentVisitId(),
              ]);
            }, 500);

            this.swalToastService.toastSuccess(
              'Patient assigned to bed successfully',
            );
          },
          error: (err) => {
            this.swalToastService.toastError('Unable to assign patient to bed');
            this.isAssignLoading = false;
          },
        });
    } else {
      this.isAssignLoading = false;
    }
  }

  handleTypeChange(event: any) {
    if (event == 4) {
      this.dischargeForm.get('dischargeSituationValue')?.setValue(5);
      this.situationDisabled = true;
    } else {
      this.dischargeForm.get('dischargeSituationValue')?.setValue(undefined);
      this.situationDisabled = false;
    }
  }

  handleDischarge(item: IInpatient) {
    this.dischargeForm.reset();

    this.dischargeForm
      .get('eocValue')
      ?.setValue(item?.inPatientInfo?.episodeOfCareId);

    this.isDischargeVisible = true;
    this.isDischargeLoading = true;

    this.dischargeService
      .getDischargeDropdown(item?.inPatientInfo?.episodeOfCareId?.toString())
      .subscribe({
        next: (res) => {
          this.dischargeDropdown = res.data;

          this.finalDiagnosis = res.data.finalDiagnostic.map((d) => ({
            label: d?.name,
            value: d?.id,
          }));

          this.dischargeForm
            .get('diagnosisValue')
            ?.setValue(res.data.potentialDiagnosis.id);

          this.isDischargeLoading = false;

          this.paginator.pageIndex = 0;
          this.searchPatientsForm();
        },
        error: (err) => {
          this.swalToastService.toastError(
            'Unable to retrieve discharge options',
          );
        },
      });
  }

  handleAdd(item: IInpatient) {
    this.bedForm.reset();
    if (item.id) {
      this.bedForm.get('bedValue')?.setValue(item?.id);
      this.isAssignVisible = true;
      this.isAssignLoading = true;
      this.inpatientService.getAvailablePatients().subscribe({
        next: (d) => {
          this.availablePatients = d.data.availablePatients.map((d) => {
            return {
              label: d.fullName,
              value: d.id,
            };
          });

          this.reasons = d.data.admissionReasons;
          this.isAssignLoading = false;
        },
        error: (err) => {
          this.swalToastService.toastError(
            'Unable to retrieve available Patients',
          );
        },
      });
    }
  }

  handleVisit(item: IInpatient) {
    this.isLoading = true;
    if (item?.inPatientInfo?.episodeOfCareId) {
      this.eocService
        .getDraftVisitFromEOC(item.inPatientInfo.episodeOfCareId)
        .subscribe({
          next: (res) => {
            this.existingVisits = res?.data;

            // REQUEST NEW VISIT AND ASSIGN VISIT ID TO EOC SERVICE THEN NAVIGATE
            // this.eocService.currentVisitId.set(res?.data?.visitId?.toString());
            // this.router.navigate(['/inPatientView']);
            Swal.fire({
              title: `<span style="font-size: 20px;">${this.translate.instant(
                'Visit',
              )}</span> <span style="font-size: 16px; font-weight: normal">(${this.translate.instant(
                'In Patient',
              )})</span>`,
              html: `
              <div>
                <input type="radio" id="newVisit" name="visitOption" value="new" checked>
                <label for="newVisit">${this.translate.instant(
                  'Create New Visit',
                )}</label>
              </div>
            
              ${
                this.existingVisits?.length
                  ? `
                  <div style="padding-top: 15px">
                    <input type="radio" id="existingVisit" name="visitOption" value="existing">
                    <label for="existingVisit">${this.translate.instant(
                      'Select Draft Visit',
                    )}</label>
                  </div>
                  <div id="visitDropdownContainer" style="margin-top: 10px;">
                    <select id="visitSelect" style="width: 100%; padding: 5px;">
                      <option value="">${this.translate.instant(
                        'Select Draft Visit',
                      )}</option>
                      ${this.existingVisits
                        .map(
                          (visit) =>
                            `<option value="${visit.id}">${visit.date}${
                              visit?.notes ? ' | ' + visit.notes : ''
                            }</option>`,
                        )
                        .join('')}
                    </select>
                  </div>
                `
                  : ''
              }
            `,
              didOpen: () => {
                const dropdown = document.getElementById(
                  'visitSelect',
                ) as HTMLSelectElement;
                const existingRadio = document.getElementById(
                  'existingVisit',
                ) as HTMLInputElement;
                const newRadio = document.getElementById(
                  'newVisit',
                ) as HTMLInputElement;

                // When selecting a visit from the dropdown, auto-check the existing radio
                if (dropdown && existingRadio) {
                  dropdown.addEventListener('change', () => {
                    if (dropdown.value && !existingRadio.checked) {
                      existingRadio.checked = true;
                    }
                  });
                }

                // When reselecting "Create New Visit", reset dropdown selection
                if (dropdown && newRadio) {
                  newRadio.addEventListener('change', () => {
                    if (newRadio.checked) {
                      dropdown.value = '';
                    }
                  });
                }
              },
              preConfirm: () => {
                const selectedOption = document.querySelector(
                  'input[name="visitOption"]:checked',
                ) as HTMLInputElement;
                const selectedVisitId = (
                  document.getElementById('visitSelect') as HTMLSelectElement
                )?.value;

                if (selectedOption.value === 'existing' && !selectedVisitId) {
                  Swal.showValidationMessage(
                    this.translate.instant('Select Draft Visit'),
                  );
                  return false;
                }

                if (selectedOption.value === 'new' && selectedVisitId) {
                  Swal.showValidationMessage(
                    this.translate.instant('Review your selection'),
                  );
                  return false;
                }

                return {
                  selectedOption: selectedOption.value,
                  selectedVisitId,
                };
              },
              showDenyButton: false,
              showCancelButton: true,
              cancelButtonText: `${this.translate.instant('Cancel')}`,
              confirmButtonText: `${this.translate.instant('Ok')}`,
            }).then((result) => {
              if (result.isConfirmed) {
                this.isNewVisitLoading = true;

                const selectedOption = document.querySelector(
                  'input[name="visitOption"]:checked',
                ) as HTMLInputElement;
                const selectedVisitId = (
                  document.getElementById('visitSelect') as HTMLSelectElement
                )?.value;

                if (selectedOption.value == 'existing') {
                  item.inPatientInfo.episodeOfCareId &&
                    this.eocService.currentEocId.set(
                      item.inPatientInfo.episodeOfCareId.toString(),
                    );

                  selectedVisitId &&
                    this.eocService.currentVisitId.set(selectedVisitId);

                  this.isLoading = false;
                  this.isNewVisitLoading = false;
                  this.patientService.patientIDsignal.set(
                    item.inPatientInfo?.patientId?.toString(),
                  );

                  // RESET DATA  BEFORE ACCESSING A PATIENT
                  this.clearDataFromServices();

                  this.router.navigate([
                    '/ehr/inPatientView',
                    this.patientService.patientIDsignal(),
                    this.eocService.currentEocId(),
                    this.eocService.currentVisitId(),
                  ]);
                } else {
                  this.eocService
                    .createNewVisit(item.inPatientInfo.episodeOfCareId)
                    .subscribe({
                      next: (res) => {
                        res?.data?.episodeOfCareId?.toString() &&
                          this.eocService.currentEocId.set(
                            res?.data?.episodeOfCareId?.toString(),
                          );

                        res?.data?.visitId?.toString() &&
                          this.eocService.currentVisitId.set(
                            res?.data?.visitId?.toString(),
                          );

                        this.isLoading = false;
                        this.isNewVisitLoading = false;
                        this.patientService.patientIDsignal.set(
                          item.inPatientInfo?.patientId?.toString(),
                        );

                        // RESET DATA  BEFORE ACCESSING A PATIENT
                        this.clearDataFromServices();

                        this.router.navigate([
                          '/ehr/inPatientView',
                          this.patientService.patientIDsignal(),
                          this.eocService.currentEocId(),
                          this.eocService.currentVisitId(),
                        ]);

                        this.swalToastService.toastSuccess(
                          'New Visit created successfully',
                        );
                      },
                      error: (err) => {
                        this.swalToastService.toastError(
                          'Unable to create New Visit',
                        );
                      },
                    });
                }
              } else {
                this.isLoading = false;
                this.isNewVisitLoading = false;
              }
            });
          },
          error: (err) => {
            this.swalToastService.toastError('Something went wrong');
          },
        });
    }
  }

  resetVisitCancel() {
    this.isNewSelected = true;
    this.isVisitVisible = false;
    this.draftVisit = undefined;
    this.selectedEOC = undefined;
    this.selectedPatientID = undefined;
    this.clearDataFromServices();
  }

  handleView(item: IInpatient) {
    this.router.navigate([
      '/ehr/profile/' +
        item.inPatientInfo.patientId +
        '/' +
        item.inPatientInfo.episodeOfCareId,
    ]);
  }

  openMove(item: IInpatient) {
    this.selectedPatientFullName = item.inPatientInfo.patientFullName;
    this.selectedPatientID = item.inPatientInfo.id;
    this.isMoveVisible = true;
  }

  openVisit(item: IInpatient) {
    this.isLoading = true;
    if (item?.inPatientInfo?.episodeOfCareId) {
      this.eocService
        .getDraftVisitFromEOC(item.inPatientInfo.episodeOfCareId)
        .subscribe({
          next: (res) => {
            this.existingVisits = res?.data || [];
            this.selectedPatientFullName = item.inPatientInfo.patientFullName;
            this.selectedPatientID = item.inPatientInfo.patientId;
            this.selectedEOC = item.inPatientInfo.episodeOfCareId;
            this.isVisitVisible = true;
            this.isLoading = false;
          },
          error: (err) => {
            this.isLoading = false;
          },
        });
    }
  }

  refreshTable() {
    this.paginator.pageIndex = 0;
    this.searchPatientsForm();
  }

  getProfilePicture(id: string) {
    this.patientService.getProfilePicture(id).subscribe({
      next: (res) => {
        return res;
      },
      error: (err) => {
        console.log(err);
      },
    });
    return undefined;
  }

  selectNewVisit() {
    this.isNewSelected = true;
  }

  selectDraftVisit() {
    this.isNewSelected = false;
  }

  handleVisitSubmit() {
    if (
      !this.isNewSelected &&
      this.draftVisit &&
      this.selectedEOC &&
      this.selectedPatientID
    ) {
      this.selectedEOC &&
        this.eocService.currentEocId.set(this.selectedEOC.toString());

      this.draftVisit &&
        this.eocService.currentVisitId.set(this.draftVisit.toString());

      this.patientService.patientIDsignal.set(
        this.selectedPatientID.toString(),
      );

      this.visitModalRef.afterClose.subscribe((result) => {
        if (result === 'success') {
          this.router.navigate([
            '/ehr/inPatientView',
            this.patientService.patientIDsignal(),
            this.eocService.currentEocId(),
            this.eocService.currentVisitId(),
          ]);

          this.resetVisitCancel();
        }
      });
      this.visitModalRef.destroy('success');
    } else if (
      this.isNewSelected &&
      this.selectedEOC &&
      this.selectedPatientID
    ) {
      this.eocService.createNewVisit(this.selectedEOC).subscribe({
        next: (res) => {
          res?.data?.episodeOfCareId?.toString() &&
            this.eocService.currentEocId.set(
              res?.data?.episodeOfCareId?.toString(),
            );

          res?.data?.visitId?.toString() &&
            this.eocService.currentVisitId.set(res?.data?.visitId?.toString());

          this.patientService.patientIDsignal.set(
            this.selectedPatientID?.toString()!,
          );

          this.visitModalRef.afterClose.subscribe((result) => {
            if (result === 'success') {
              this.router.navigate([
                '/ehr/inPatientView',
                this.patientService.patientIDsignal(),
                this.eocService.currentEocId(),
                this.eocService.currentVisitId(),
              ]);

              this.resetVisitCancel();
            }
          });
          this.visitModalRef.destroy('success');

          this.swalToastService.toastSuccess('New Visit created successfully');
        },
        error: (err) => {
          this.swalToastService.toastError('Unable to create New Visit');
        },
      });
    }
  }

  formatDate(date?: string) {
    return date ? moment(date).format(date_format) : '';
  }
}
